import { createFileRoute } from '@tanstack/react-router';
import { GongCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/gong/callback')({
  component: GongCallbackPage,
});
